<template>
  <div class="app-container">
    <!-- <el-tabs v-model="searchParam.status" type="card" @tab-click="getList">
            <el-tab-pane label="上架" name="2"></el-tab-pane>
            <el-tab-pane label="下架" name="1"></el-tab-pane>
        </el-tabs> -->
    <div class="search-bar flex">
      <!-- <div class="left">
                <div class="search-bar">
                    <el-input v-model="searchParam.keyword_search" suffix-icon="el-icon-search" placeholder="输入要搜索的内容" clearable @clear="getList"></el-input>
                    <el-button type="primary" @click="searchList">搜索</el-button>
                </div>
            </div> -->
      <div v-if="tableData.length < 1" class="right">
        <el-button type="primary" size="small" @click="addClassification"> 新建 </el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="value" label="手机号"></el-table-column>
        <!-- <el-table-column prop="create_time" label="添加时间"></el-table-column> -->
        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="editItem(scope.row)">编辑</el-button>
            <!-- <el-button v-if="scope.row.status==2" class="mid-red" @click="xiajia(scope.row,1)">下架</el-button>
                        <el-button v-else class="mid-blue" @click="xiajia(scope.row,2)">上架</el-button> -->
            <!-- <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="page">
                <pagination
                    v-show="total > 0"
                    :total="total"
                    :page.sync="listQuery.page_index"
                    :limit.sync="listQuery.page_size"
                    @pagination="getList"
                />
            </div> -->
    </div>

    <el-drawer
      ref="drawer"
      :title="form.uuid ? '编辑' : '新增'"
      :visible.sync="showDrawer"
      direction="rtl"
      custom-class="drawer"
    >
      <div class="drawer-content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="电话号码" prop="value">
            <el-input v-model="form.value" autocomplete="off" maxlength="11" show-word-limit />
          </el-form-item>
        </el-form>
        <div class="drawer-footer">
          <el-button class="btn" @click="cancelForm">取 消</el-button>
          <el-button class="btn" type="primary" :loading="submitLoading" @click="onSubmitClick">{{
            submitLoading ? "提交中 ..." : "保 存"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {
  getSystemConfig,
  addSystemConfig,
  editSystemConfig,
  getCate,
  addCate,
  editCate,
  deleteCate,
  setCateStatus,
} from "@/api/product.js";
export default {
  components: { Pagination },
  data() {
    return {
      total: 10,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      searchParam: {
        keyword_search: "",
      },
      tableData: [],
      editId: null,
      showDrawer: false,
      submitLoading: false,
      form: {
        code: "contact",
        value: "",
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    xiajia(row, type) {
      this.$confirm("确定要" + (type == 1 ? "下架" : "上架") + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO: 分类下架接口对接
          setCateStatus(row.uuid).then((res) => {
            if (res) {
              this.$notify({
                title: "操作成功",
                type: "success",
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 验证手机号
    validateMobileNumber(mobileNumber) {
      // 使用正则表达式验证手机号，支持常见的手机号格式
      const regex = /^1[3456789]\d{9}$/;
      return regex.test(mobileNumber);
    },
    // 验证座机号
    validatePhoneNumber(phoneNumber) {
      // 使用正则表达式验证座机号，支持常见的座机号格式
      const regex = /^(0\d{2,3}-)?\d{7,8}$/;
      return regex.test(phoneNumber);
    },
    deleteItem(row) {
      this.$confirm("确定要删除该分类吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO: 分类删除接口对接
          deleteCate(row.uuid).then((res) => {
            if (res) {
              this.$notify({
                title: "操作成功",
                type: "success",
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList() {
      const res = await getSystemConfig({
        ...this.listQuery,
        ...this.searchParam,
      });
      // console.log(res, '---')
      // if (res.data instanceof Array) {
      this.tableData = [res];
      // this.total = res.total
      // }
      // TODO: 分类列表接口对接
    },

    searchList() {
      this.listQuery.page_index = 1;
      this.getList();
    },

    // 新增\修改 分类
    editItem(row) {
      this.setDefault();
      this.showDrawer = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.form = { id: row.id, code: "contact", value: row.value };
    },
    setDefault() {
      this.form = { code: "contact", value: "" };
    },
    addClassification() {
      this.showDrawer = true;
      this.setDefault();
      if (this.$refs.form) this.$refs.form.resetFields();
    },
    cancelForm() {
      this.showDrawer = false;
    },
    onSubmitClick() {
      // this.$refs["form"].validate(async valid => {
      //     if (valid) {
      this.submitLoading = true;
      const p = this.validateMobileNumber(this.form.value);
      const z = this.validatePhoneNumber(this.form.value);
      if (!p && !z) {
        this.$notify({ title: "电话输入有误", type: "error" });
        this.submitLoading = false;
        return false;
      }
      if (!this.form.id) {
        addSystemConfig(this.form).then((res) => {
          if (res) {
            this.$notify({ title: "操作成功", type: "success" });
            this.getList();
            this.submitLoading = false;
            // this.$refs.form.resetFields();
            this.$refs.drawer.closeDrawer();
          }
        });
        // TODO: 分类新增接口对接
        // await saveMenu(data).catch(error => {
        //     this.submitLoading = false;
        //     throw error;
        // });
      } else {
        const obj = { ...this.form };
        const oid = this.form.id;
        delete obj.id;
        editSystemConfig(obj, oid).then((res) => {
          this.$notify({ title: "操作成功", type: "success" });
          this.getList();
          this.submitLoading = false;
          // this.$refs.form.resetFields();
          this.$refs.drawer.closeDrawer();
        });
      }
      // }
      // });
    },
  },
};
</script>

<style scoped="scoped">
.app-container {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}

.drawer-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
}

.drawer-footer {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.btn {
  width: 50%;
}
</style>
